import type { RotationLocale } from "@/locales/fr/rotation";

const rotationLocale: RotationLocale = {
  rotation: {
    title: "Rotation",
    rotationRequest: "Submit a rotation",
    detachSubscriber: "Detach subscriber",
    siteWithAppointment:
      "This site has an appointment scheduled. It is not possible to detach the member if the appointment is maintained.",
    deleteAppointment: "Delete the appointment before detachment",
  },
};

export default rotationLocale;
